import { Country, State, City } from 'country-state-city';

// Get all countries sorted alphabetically
export const getCountries = () => {
  const countries = Country.getAllCountries();
  return countries
    .map(country => country.name)
    .sort();
};

// Get all country objects with ISO codes
export const getCountriesWithCodes = () => {
  return Country.getAllCountries().sort((a, b) => a.name.localeCompare(b.name));
};

// Get states for a country by country name
export const getStates = (countryName) => {
  if (!countryName) return [];
  
  const countries = Country.getAllCountries();
  const country = countries.find(c => c.name === countryName);
  
  if (!country) return [];
  
  const states = State.getStatesOfCountry(country.isoCode);
  return states
    .map(state => state.name)
    .sort();
};

// Get cities for a state in a country
export const getCities = (countryName, stateName) => {
  if (!countryName || !stateName) return [];
  
  const countries = Country.getAllCountries();
  const country = countries.find(c => c.name === countryName);
  
  if (!country) return [];
  
  const states = State.getStatesOfCountry(country.isoCode);
  const state = states.find(s => s.name === stateName);
  
  if (!state) return [];
  
  const cities = City.getCitiesOfState(country.isoCode, state.isoCode);
  return cities
    .map(city => city.name)
    .sort();
};

// Get country ISO code by name
export const getCountryCode = (countryName) => {
  const countries = Country.getAllCountries();
  const country = countries.find(c => c.name === countryName);
  return country ? country.isoCode : null;
};
